import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WrappedMap from "./GoogleMapDetails";
import { API_ENDPOINT } from 'services/Api';
import { useSearchParams } from 'react-router-dom';
import { getRideDetailsPolylines } from 'redux/actions/UserGoogleMap';
import Loader from 'components/loader/Loader';

function MapTest() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);

  const queryParams = {
    magicToken: params?.magicToken || "",
    tripId: params?.tripId || "",
  };

  useEffect(() => {
    if (queryParams?.tripId) {
      dispatch(getRideDetailsPolylines(queryParams?.tripId));
    }
  }, [dispatch, queryParams?.tripId]);

  const googleData = useSelector((state) => state?.userRideDetailsPolylines?.userRideDetails?.data?.coordinates);
  const googleDataLoading = useSelector((state) => state?.userRideDetailsPolylines?.loading);

  // Initialize segments array
  let segments = [];

  // Check if googleData is an array and process it based on its structure
  if (Array.isArray(googleData)) {
    if (Array.isArray(googleData[0][0])) {
      // Multi-segmented trip data
      segments = googleData.map(segment =>
        segment.map(coord => ({
          lat: parseFloat(coord[0]),
          lng: parseFloat(coord[1]),
        }))
      );
    } else {
      // Single-segment trip data
      segments = [googleData.map(coord => ({
        lat: parseFloat(coord[0]),
        lng: parseFloat(coord[1]),
      }))];
    }
  }
  
  let mapURL = `${API_ENDPOINT?.MapApi?.api}js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

  const status = 'dispatched'; // or 'dispatched'

 // Set window.mapApiSuccess to false initially
 useEffect(() => {
  window.mapApiSuccess = false;

  // Add event listener for 'mapApiSuccess'
  const handleMapApiSuccess = () => {
    window.mapApiSuccess = true;
  };

  window.addEventListener("mapApiSuccess", handleMapApiSuccess);

  // Cleanup event listener when component unmounts
  return () => {
    window.removeEventListener("mapApiSuccess", handleMapApiSuccess);
  };
}, []);

// Effect to dispatch the 'mapApiSuccess' event when googleData is successfully loaded
useEffect(() => {
  if (googleData?.length > 0) {
    const mapApiSuccessEvent = new Event("mapApiSuccess");
    window.dispatchEvent(mapApiSuccessEvent);
  }
}, [googleData]);

  return (
    <div>
      {googleDataLoading ? <Loader /> :
      <div className="width100 height100vh">
        <WrappedMap
          segments={segments}  // Pass the segments directly
          googleMapURL={mapURL}
          status={status}
          loadingElement={<div className='height100' />}
          mapElement={<div className='height100' />}
          containerElement={<div className='mapContainer' />}
        />
      </div>}
    </div>
  );
}

export default MapTest;
